<div
    [class.overflow-auto]="overflow()"
    [ngClass]="{
        'bg-white z-20 shadow-md theme-border border': variant() === 'default',
        'bg-transparent': variant() === 'flat',
    }"
    class="flex flex-col py-2 rounded-md min-w-max"
>
    <ng-content />
</div>
